// core/WidgetPendingChanges.ts
/** Type Guard: реализует ли объект WidgetPendingChanges */
function isWidgetPendingChanges(x) {
    return !!x && typeof x.flushPendingChanges === 'function';
}

export { isWidgetPendingChanges };
